/**
 * Created by yuanlei on 2019/12/10.
 */
/**
 * api接口的统一出口
 */
// 文章模块接口
import apis from '@/api/api';
// 其他模块的接口……

// 导出接口
export default {
  apis,
  // ……
}



// WEBPACK FOOTER //
// ./src/api/index.js